import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronRight"><Path fillRule="evenodd" clipRule="evenodd" d="M8.64645 3.64645C8.84171 3.45118 9.15829 3.45118 9.35355 3.64645L15.9393 10.2322C16.9156 11.2085 16.9157 12.7914 15.9393 13.7677L9.35355 20.3536C9.15829 20.5488 8.84171 20.5488 8.64645 20.3536C8.45118 20.1583 8.45118 19.8417 8.64645 19.6464L15.2322 13.0606C15.818 12.4749 15.818 11.5251 15.2322 10.9393L8.64645 4.35355C8.45118 4.15829 8.45118 3.84171 8.64645 3.64645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRight;
